import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { register } from './actions';
import { Row, Col } from 'antd';
import { Button, Input } from '../../components';
import { Link, useNavigate } from 'react-router-dom';
import { validateEmail, validatePhone } from '../../utils/helpers';
import { toast } from 'react-toastify';
import { Strings } from '../../utils/strings';

const SignUp = () => {
  const [email, setEmail] = useState('');
  const [phone, setPhone] = React.useState('');
  const [password, setPassword] = React.useState('');
  const [firstName, setFirstName] = React.useState('');
  const [lastName, setLastName] = React.useState('');
  const [zipCode, setZipCode] = useState('');
  const loading = useSelector((s) => s.auth.user.loading);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const registerFunc = React.useCallback(() => {
    if (!validateEmail(email)) return toast.warn('Email is not valid');
    if (!validatePhone(phone)) return toast.warn('Phone is not valid');
    dispatch(
      register({
        firstName,
        lastName,
        email,
        phone,
        password,
        zipCode,
        navigate,
      })
    );
  }, [
    firstName,
    lastName,
    email,
    password,
    phone,
    zipCode,
    dispatch,
    navigate,
  ]);

  const handlePhoneChange = (value) => {
    setPhone(value);
  };
  const handleZipCode = (value) => {
    setZipCode(value);
  };
  return (
    <Row style={{ height: window.innerHeight }} className="loginContainer">
      <Col md={12}>
        <div>
          <div className="left">
            <img
              src={require('../../images/logo.png')}
              style={{ width: '200px' }}
              alt="Woosla"
              className="logo"
            />
            <h2>Sign Up</h2>
            <Input
              placeholder="First Name"
              value={firstName}
              onChange={setFirstName}
            />
            <Input
              placeholder="Last Name"
              value={lastName}
              onChange={setLastName}
            />
            <Input placeholder="Email" value={email} onChange={setEmail} />
            <Input
              placeholder="Phone"
              value={phone}
              onChange={(value) => handlePhoneChange(value)}
              type="number"
            />
            <Input
              placeholder="Password"
              value={password}
              onChange={setPassword}
              type="password"
            />
            <Input
              placeholder="Zip code"
              value={zipCode}
              onChange={(value) => handleZipCode(value)}
              type="number"
            />
            <Button title="Sign Up" onClick={registerFunc} disabled={loading} />
            <p>
              Do you have an account? <Link to="/login">Sign In</Link>
            </p>
          </div>
        </div>
      </Col>
      <Col md={12}>
        <div
          className="right"
          style={{
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignContent: 'center',
            alignItems: 'center',
          }}
        >
          <Row align={'middle'}>
            <img
              //  src={require("../../images/login.svg").default}
              src={require('../../images/login.png')}
              alt=""
              style={{ width: '100%' }}
            />
          </Row>
          <Row className="loginPromoRow">
            <span className="loginPromoText">{Strings.Login.promoText}</span>
            {Strings.Login.subText}
          </Row>
        </div>
      </Col>
    </Row>
  );
};

export default SignUp;
